import { Injectable } from "@angular/core";

import {
  OrderDataPromiseLookupService,
  SystemConfigPromiseService,
  TraderGroupPromiseLookupService,
  BfxBlotterOrdersContextMenuPromiseService,
  ActiveUserProfilePromiseService,
} from "shared/cubiq-services";

import { BfxBlotterOrdersActionSubject } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { BfxBlotterOrdersContextMenuService } from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxLadderOrdersContextMenuService extends BfxBlotterOrdersContextMenuService {
  constructor(
    orderDataService: OrderDataPromiseLookupService,
    systemConfigService: SystemConfigPromiseService,
    traderGroupService: TraderGroupPromiseLookupService,
    activeUserService: ActiveUserProfilePromiseService,
    contextMenuService: BfxBlotterOrdersContextMenuPromiseService,
    // note this is shared with Orders+Inbox(via subclass)+Ladder(via providers in component)
    actionSubject: BfxBlotterOrdersActionSubject,
  ) {
    super(
      orderDataService,
      systemConfigService,
      traderGroupService,
      activeUserService,
      contextMenuService,
      actionSubject,
    );
  }
}
